// extracted by mini-css-extract-plugin
module.exports = {"nav":"NavLinks_nav__1oC4z","active":"NavLinks_active__1f4Lk","white":"NavLinks_white__2bmHY"};